import getDefaultState  from './moduleSurveyState'
import { accessNestedProperty } from './sharedMethods'

export default {

  'RESET_SURVEY_STATE' (state) {
    //noconsoleconsole.log('resetting survey state')
    Object.assign(state, getDefaultState())
  },    

  'COMPUTE_RATING_TYPE' (state) {
        // determine what the default rating should be, based on 
        // the FIRST rating question. If no rating q, then default to star.
        let rating = 'star'              
        for (const step of state.surveyFlow) {
          //noconsoleconsole.log(step)
          if (step.type === 'ratingq') {
            rating = step.ratingType
            break
          }
        }
        state.surveySetup.ratingType = rating
  },
  'UPDATE_INVITE_ONLY' (state, newVal) {
    state.surveySetup.inviteOnly = newVal
  },
  //MUTATIONS FOR SURVEY FLOW

  'SYNC_FLOW' (state, setup) {
    //load survey flow from DB entity record into view state, for local manipulation in views          
    state.surveyFlow = JSON.parse(JSON.stringify(setup.surveyFlow))
    


    const toCommit = {...setup}
    delete toCommit.surveyFlow



    //check if we have the optional field: inviteOnly
    if (typeof toCommit.inviteOnly === 'undefined') {
      toCommit.inviteOnly = false
    }


    state.surveySetup = toCommit
  },

  'CHANGE_FOCUS_INDEX' (state, id) {
    //is the spread operator needed here?     
    state.currentFocusIndex = id
  },

  'CHANGE_FOCUS_ERROR_STATE' (state, hasErrors) {
    //is the spread operator needed here?     
    state.currentFocusIndexHasErrors = hasErrors
  },

  'HIGHLIGHT_STEP' (state, id) {
    //is the spread operator needed here? 
    state.stepHighlightIndex = id
  },

  'CHANGE_FLOW' (state, flow) {
    //is the spread operator needed here? 
    state.surveyFlow = flow
  },

  'CHANGE_RATING_TYPE' (state, newRating) {
    state.surveySetup.ratingType = newRating
  },

  'CHANGE_FIELD' (state, { fieldAddress, val }) {    
    const localizedFieldAddress = [...fieldAddress]
    localizedFieldAddress.shift()
    accessNestedProperty(state.surveyFlow[fieldAddress[0]], localizedFieldAddress, val)
  },

  'ADD_TIP' (state, { index, tip }) {
    
  },

  'REMOVE_TIP' (state, { index, tipIndex }) {
    
  }

  //END MUTATIONS FOR SURVEY FLOW
}